import React, { useRef } from 'react';
import StandaloneSendForm from '../../../Components/Sends/StandaloneSendForm';
import StandaloneSendTemplateNavigation from '../../../Components/Sends/StandaloneSendTemplateNavigation';
import SendMailProvider from '../../../Providers/SendMailProvider';
import UserPageHeader from '../../../Components/Sends/Controls/UserPageHeader';
import UserPageFooter from '../../../Components/Sends/Controls/UserPageFooter';
import { useParams } from 'react-router-dom';
import { useLayout } from '../../../Framework/Providers/LayoutProvider';
import BasicContent from '../../../Framework/Components/PageLayouts/BasicContent';
import StackVertical from '../../../Framework/Components/Wrappers/StackVertical';
import { FlexAlign, FlexGap, FlexJustify } from '../../../Framework/Data/Enums/LayoutEnums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons';
import { StandaloneSendsHistoryOverview } from '../../../Components/Sends/StandaloneSendsHistoryOverview';
import SendMailHistoryProvider from '../../../Providers/SendMailHistoryProvider';

const UserSendsPage = () => {
	const { pageId } = useParams();
	const { isMedium } = useLayout();

	const containerRef = useRef<any>(null);

	return (
		<BasicContent ref={containerRef}>
			<UserPageHeader />

			<div className={`row ${!isMedium ? 'pl-sm pr-sm' : 'mt-sm'} mb-xl`}>
				<div className={'col-xs-12 col-center-md-8 col-center-lg-10 col-center-xxl-8'}>
					<div className='row no-gap'>
						<div className='col-xs-12 col-lg-4'>
							<StandaloneSendTemplateNavigation containerRef={containerRef} />
						</div>

						<div className='col-xs-12 col-lg-8'>
							{pageId && (
								<SendMailProvider>
									<StandaloneSendForm />
								</SendMailProvider>
							)}

							{!pageId && (
								<div
									style={{
										borderRadius: 'var(--border-radius)',
										display: 'flex',
										background: 'var(--secondary-bg)',
										height: '53.5em',
										alignItems: 'center',
										justifyContent: 'center',
									}}
								>
									<StackVertical
										gap={FlexGap.ExtraSmall}
										align={FlexAlign.Center}
										justify={FlexJustify.Center}
										extraClass={'m-xxl p-xxl text-center'}
									>
										<FontAwesomeIcon icon={faPaperPlane} size={'3x'} />
										<h6 className={'sub-heading mt-sm mb-xs'}>No Profiles</h6>
										<p>You haven't been given access to any profiles yet</p>
									</StackVertical>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>

			<UserPageFooter />
		</BasicContent>
	);
};

export default UserSendsPage;
